/** @format */

import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { HmfTextLinkComponent } from '@dsg-tech/homefield-angular';
import { HomefieldAccordionModule } from '@homefield';
import { ProductListSEO } from '@shared/data-access/interfaces';
import { TitleCasePipe } from '@angular/common';

/** @format */

@Component({
	selector: 'shared-components-seo-content',
	imports: [TitleCasePipe, HmfTextLinkComponent, HomefieldAccordionModule],
	templateUrl: './seo-content.component.html',
	styleUrl: './seo-content.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class SeoContentComponent {
	readonly productListSEOData = input.required<ProductListSEO>();

	readonly seoTabContentList = computed(
		() => this.productListSEOData()?.sanitizedAttributes?.seoTabsContent
	);
	readonly seoHeader = computed(
		() => this.productListSEOData()?.sanitizedAttributes?.seoHeadline
	);
	readonly featuredLinks = computed(
		() => this.productListSEOData()?.sanitizedAttributes?.seoFeaturedLinks
	);

	trackByHeader(index: number, header: string): string {
		return index.toString() + header;
	}

	trackByKey(index: number, key: string): string {
		return index.toString() + key;
	}
}
